import {BestPriceTabs} from "@Pages/stationToStation/features/bestPriceTabs/components/BestPriceTabs";
import BestPriceOnDateRouteListTravel from "@Pages/stationToStation/components/BestPriceOnDateRouteListTravel";
import React, {useState} from "react";
import BestPriceRouteType from "@Pages/stationToStation/types/BestPriceRoute.type";

interface TravelBestPricePortalProps {
    bestPriceOnDateRoutes: Record<string, BestPriceRouteType[]>
}

export const TravelBestPricePortal = ({bestPriceOnDateRoutes}: TravelBestPricePortalProps) => {
    const [activeTab, setActiveTab] = useState(Object.keys(bestPriceOnDateRoutes)[0])

    return (
        <>
            <div
                className="result-tabs"
                id="result-tabs"
            >
                <BestPriceTabs
                    tab={activeTab}
                    setTab={setActiveTab}
                    bestPriceOnDateRoutes={{bestPriceOnDateRoutes}}
                />
            </div>
            {Object.keys(bestPriceOnDateRoutes).map((key, index: number) => (
                <BestPriceOnDateRouteListTravel
                    key={index}
                    index={key}
                    bestPriceOnDateData={bestPriceOnDateRoutes[key]}
                    activeTab={activeTab}
                />
            ))}
        </>
    )
}